
import { Component, Vue } from 'vue-property-decorator'
import { applicantStore, classifiersStore } from '@/store'
import { ClassifiersUtils } from '@/commons/utils/classifiers'
import { ApplicationUtils } from '@/commons/utils/application'
import { LocaleMessages } from 'vue-i18n'

@Component
export default class ApplicantInfo extends Vue {
    get placeOfBirth (): string {
        return applicantStore.applicationApplicant.birthCountry || ''
    }

    get educationLabel (): string {
        return ClassifiersUtils.translateByCode(classifiersStore.educations, applicantStore.applicationApplicant.education)
    }

    get nationalityLabel (): string {
        return ClassifiersUtils.translateByCode(classifiersStore.nationalities, applicantStore.applicationApplicant.nationality)
    }

    get nativeLanguageLabel (): string {
        return ClassifiersUtils.translateByCode(classifiersStore.nativeLanguages, applicantStore.applicationApplicant.nativeLanguage)
    }

    get blockTitle (): string | LocaleMessages {
        return this.$t(ApplicationUtils.getApplicantRelationTitle())
    }
}
